import { create } from "zustand";

/**
 * Zustand store for the India NSE OTM Screener.
 * Populated by the server-side India Straddle Monitor via the global LTP WebSocket.
 */
const useIndiaOtmStore = create((set) => ({
    straddles: [],
    lastUpdated: null,

    setSnapshot: (data) =>
        set({
            straddles: Array.isArray(data) ? data : [],
            lastUpdated: Date.now(),
        }),

    clearSnapshot: () => set({ straddles: [], lastUpdated: null }),
}));

export default useIndiaOtmStore;
